<template>
  <article class="card stats-item">
    <header class="header"><slot name="header" /></header>
    <p><slot /></p>
  </article>
</template>

<style scoped>
.stats-item {
  .header {
    display: flex;
    gap: var(--spacing-sm);
  }
  p {
    text-align: center;
    font-size: var(--font-size-xxxl);
    font-weight: var(--font-weight-bold);
  }
}
</style>
